<template>
    <div><!-- 招標及報價查詢 -->
        <CCard>
            <CCardBody>
                <SearchBar :finishInvalidCount="finishInvalidCount"
                           @doSearchEvent="doSearchEvent"
                ></SearchBar>
            </CCardBody>
        </CCard>
        <CCard>
            <CCardBody class="table_body">
                <div class="table-container">
                    <vue-bootstrap4-table ref="purchaseBs4Table" class="" 
                        :rows="purchaseSearchObj.rows" 
                        :columns="columns" 
                        @on-change-query="onChangeQuery"
                        :total-rows="purchaseSearchObj.totalCount"
                        :config="config" :classes="classes" >
                        <template v-if="isTw" slot="empty-results">
                            查無結果
                        </template>
                        <template v-if="isTw" slot="pagination-info" slot-scope="props">
                            {{paginationInfoTwText(props)}}
                        </template>
                        <template slot="func" slot-scope="props">
                            <button class="btn btn-sm btn-success mr-2" @click="detail(props.row.guid)">{{i18n('Buttons.DetailInfo')}}</button>
                            <button class="btn btn-sm btn-info mr-2" @click="copyPurchaseCase(props.row.guid)">{{i18n('Buttons.CopyData')}}</button>
                            <button class="btn btn-sm btn-danger mr-2" data-toggle="modal" v-if="!isCaseInvalid(props.row)" @click="setInvalidId(props.row.guid)" data-target="#deleteModal">{{i18n('Buttons.Invalid')}}</button>
                            <button class="btn btn-sm btn-warning mr-2" @click="approvedToSend(props.row.guid)" v-if="showApprovedToSend(props.row)">{{i18n('Buttons.ApprovedToSend')}}</button>
                            <button class="btn btn-sm btn-info mr-2" @click="settingCloseCase(props.row.guid)" v-if="showSettingCloseCase(props.row)">{{i18n('Buttons.SettingCloseCase')}}</button>
                            <button class="btn btn-sm btn-warning mr-2" @click="viewAttachFiles(props.row)" v-if="isShowViewAttachFiles(props.row)">{{i18n('Buttons.ViewAttachFiles')}}</button>
                        </template>
                    </vue-bootstrap4-table>
                </div>                
            </CCardBody>            
        </CCard>

        <DeleteModal @finishInvalid="finishInvalid"/>
        <!-- 查詢附件區塊 add by [Issue 2022-07-28 ,#02] -->
        <!-- Modal -->
        <div class="modal fade" id="viewAttachFilesModal_List" tabindex="-1" role="dialog" >
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        {{$t('Buttons.ViewAttachFiles')}}
                    </div>
                    <div class="modal-body">
                        <table class="table">
                            <thead class="thead-light">
                                <tr>
                                    <th class="text-center">項  目</th>
                                    <th class="text-center">檔案下載</th>                            
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in attachFilesList" :key="index">
                                    <td class="text-center">{{item.vendorName}}</td>
                                    <td class="text-center">
                                       <a v-if="hadAttachFile(item)" :href="getAttachFileUrl(item)" target="_blank">下載</a>
                                        <span v-else>無檔案</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>                        
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-gray" data-dismiss="modal">{{$t('Buttons.Cancel')}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>
</template>

<script>
import SearchBar from './SearchBar';
import DeleteModal from './DeleteModal'
import {  mapGetters, mapActions } from 'vuex'
//import $ from 'jquery'

export default {
    data() {
        return {
            columns: [
                { label: this.i18n('PurchaseTableHeader.FactoryType'), name: "factoryId",row_text_alignment: "text-left"},
                { label: this.i18n('PurchaseTableHeader.StartDate'), name: "startDate",row_text_alignment: "text-left"},
                { label: this.i18n('PurchaseTableHeader.QuoteNo'),name: "quoteNo",row_text_alignment: "text-left"},
                { label: this.i18n('PurchaseTableHeader.RequestName'), name: "requestName",row_text_alignment: "text-left"},
                { label: this.i18n('PurchaseTableHeader.RequestType'),name: "requestType",row_text_alignment: "text-left"},
                { label: this.i18n('PurchaseTableHeader.RequestWay'),name: "requestWay",row_text_alignment: "text-left"},
                { label: this.i18n('PurchaseTableHeader.NotifySupervisor'),name: "notifySupervisor",row_text_alignment: "text-left"},
                { label: this.i18n('PurchaseTableHeader.Deadline'),name: "deadline",row_text_alignment: "text-left"},
                { label: this.i18n('PurchaseTableHeader.Purchaser'),name: "purchaserName",row_text_alignment: "text-left"},
                { label: this.i18n('PurchaseTableHeader.CaseClosed'),name: "caseClosed",row_text_alignment: "text-left"},                
                { label: this.i18n('PurchaseTableHeader.Function'),name: "func",slot_name: 'func'}
            ],
            config: {
                card_mode: false,
                show_refresh_button: false,
                show_reset_button: false,
                per_page: 10,
                server_mode: true, // by default false
                per_page_options: [10, 25, 50],
                global_search: {
                    visibility: false
                }
            },
            classes: {},
            invalidId : null, //作廢單號 guid
            finishInvalidCount: 0,
            attachFilesList :[],
            activeQuoteId: ''
            //invalidContent : '',
        }
    },    
    components: {
        SearchBar,        
        DeleteModal,
    },
    computed: {
        ...mapGetters('purchaseModule', ['purchaseSearchObj']),
        ...mapGetters(['lang']),       
        isAdmin (){           
            return this.$isAdmin;
        }
    },
    watch: {
        lang: function() {            
            this.columns = [
                { label: this.i18n('PurchaseTableHeader.FactoryType'), name: "factoryId",row_text_alignment: "text-left"},
                { label: this.i18n('PurchaseTableHeader.StartDate'), name: "startDate",row_text_alignment: "text-left"},
                { label: this.i18n('PurchaseTableHeader.QuoteNo'),name: "quoteNo",row_text_alignment: "text-left"},
                { label: this.i18n('PurchaseTableHeader.RequestName'), name: "requestName",row_text_alignment: "text-left"},
                { label: this.i18n('PurchaseTableHeader.RequestType'),name: "requestType",row_text_alignment: "text-left"},
                { label: this.i18n('PurchaseTableHeader.RequestWay'),name: "requestWay",row_text_alignment: "text-left"},
                { label: this.i18n('PurchaseTableHeader.NotifySupervisor'),name: "notifySupervisor",row_text_alignment: "text-left"},
                { label: this.i18n('PurchaseTableHeader.Deadline'),name: "deadline",row_text_alignment: "text-left"},
                { label: this.i18n('PurchaseTableHeader.Purchaser'),name: "purchaserName",row_text_alignment: "text-left"},
                { label: this.i18n('PurchaseTableHeader.CaseClosed'),name: "caseClosed",row_text_alignment: "text-left"},                
                { label: this.i18n('PurchaseTableHeader.Function'),name: "func",slot_name: 'func'}
            ]
        }
    },
    methods: {        
        ...mapActions('purchaseModule', ['searchPurchase']),
        doSearchEvent (){ //按鈕呼叫查詢觸發事件
            if(this.$refs.purchaseBs4Table){
                this.$refs.purchaseBs4Table.page = 1
            }            
        },
        detail(id) { // 詳細資訊
            sessionStorage.setItem('purchaseId', id);
            this.$router.push('/purchaseedit')
            //this.$store.dispatch('alertMessageModule/updateMessage', { message: '已成功登入', status: 'success' });
        },
        copyPurchaseCase(id) { // 複製
            sessionStorage.setItem('purchaseId', '');            
            this.$router.push({name: 'PurchaseEdit', query: {purchaseId: id}})
        },
        isCaseInvalid (item){//呈現作廢按鈕的判斷
            if(item && (item.caseClosedCode === 'X' || item.caseClosedCode === 'Y')){ // || item.caseClosedCode === 'Y'
                return true;
            }
            return false;
        },
        setInvalidId (id){ //設定作廢 id ,提供給輔助視窗確認後使用
            this.invalidId = id;
        },
        finishInvalid (val){ //完成作廢文字輸入並處理作廢呼叫
            //this.invalidContent = val;
            const url = `${this.$apiUrl_Quotation}/FinishInvalid`
            const param = {guid : this.invalidId , invalidContent: val};
            this.updateLoading(true);
            this.axios.post(url, param).then((response) => {
                const {status , statusMessage} = response.data;
                this.updateLoading(false);
                if(status){
                    this.$alert(statusMessage,'警告',{type: 'warning'});
                }else{
                    //--成功          
                    this.finishInvalidCount +=1; //此計數器可觸發重新查詢呼叫          
                }                    
            })
        },
        showApprovedToSend (item){            
            if(this.isAdmin){
                if(this.isCaseInvalid(item)){
                    return true;
                }
            }
            return false;
        },
        approvedToSend (id){ //同意發送
            const url = `${this.$apiUrl_Quotation}/ApprovedToSend`
            const param = {guid : id };
            this.updateLoading(true);
            this.axios.post(url, param).then((response) => {
                const {status , statusMessage} = response.data;
                this.updateLoading(false);
                if(status){
                    this.$alert(statusMessage,'警告',{type: 'warning'});
                }else{
                    //--成功
                    this.$alert('成功：同意發放通知信件，已發送給採購人員','訊息',{});
                }                    
            })
        },
        showSettingCloseCase (item){            
            if(!this.isMember){ //非供應商
                if(item && (item.caseClosedCode === 'N')){
                    return true;
                }
            }
            return false;
        },
        settingCloseCase (id){ //指定結案
            const url = `${this.$apiUrl_Quotation}/SettingCloseCase`
            const param = {guid : id };
            this.updateLoading(true);
            this.axios.post(url, param).then((response) => {
                const {status , statusMessage} = response.data;
                this.updateLoading(false);
                if(status){
                    this.$alert(statusMessage,'警告',{type: 'warning'});
                }else{
                    //--成功
                    this.$alert('成功：指定結案已完成，已發送給採購/採購主管/稽核主管','訊息',{});
                    this.finishInvalidCount +=1; //此計數器可觸發重新查詢呼叫  
                }                    
            })
        },
        i18n (keyStr){
            return this.$t(keyStr);
        },
        onChangeQuery(queryParams) {                        
            let search =  {};
            ({StartDateBegin : search.StartDateBegin, StartDateEnd : search.StartDateEnd,DeadlineBegin : search.DeadlineBegin,DeadlineEnd : search.DeadlineEnd,QuoteNoBegin : search.QuoteNoBegin,QuoteNoEnd : search.QuoteNoEnd,RequestType : search.RequestType,PurchaserNo : search.PurchaserNo,CaseClosed : search.CaseClosed } = this.purchaseSearchObj.filter);            
            search.pageSize=queryParams.per_page;
            search.pageIndex=queryParams.page;
            //須用此方式提供 語系對應功能函數            
            search.func = (key) => this.$t(key);    
            search.fixDate = this.fixDate;        
            this.searchPurchase(search);            
        },
        paginationInfoTwText(props){            
            const {filter ,totalCount} = this.purchaseSearchObj;
            let startRecNo = 0;
            let endRecNo = 0;
            if(totalCount && totalCount > 0 && filter && filter.pageSize && filter.pageIndex){
                startRecNo = 1 + (filter.pageIndex - 1 ) * filter.pageSize;
                endRecNo = startRecNo + filter.pageSize -1;
                if(endRecNo > totalCount){
                    endRecNo = totalCount ;
                }
                return `第 ${startRecNo}筆 ~ 第 ${endRecNo}筆資料列(共${props.originalRowsLength}筆)`;
            }else{
                return '無任何資料列';
            }            
        },
        viewAttachFiles (quoteRow){// add by [Issue 2022-07-28 ,#02] 查詢附件
            debugger;
            let purchaseId = quoteRow.guid; 
            const url = `${this.$apiUrl_Quotation}/ViewAttachFilesList/${purchaseId}`;
            const _self = this;
            _self.axios.get(url, {}).then((response) => {
                if(response.data){
                    _self.activeQuoteId = purchaseId;
                    _self.attachFilesList = response.data;
                    this.jqModalShow('viewAttachFilesModal_List');
                }else{
                    this.$alert('錯誤，查詢發生錯誤!','警告',{type: 'warning'});                    
                }
            });            
        },
        hadAttachFile(item){ //檢查判斷是否有供應商上傳的檔案
            if(item && item.addFiles && item.guid){
                return true;
            }
            return false;
        },
        getAttachFileUrl(item){ //取得下載路徑
            if(item  && item.addFiles && item.guid){
                let purchaseId = this.activeQuoteId; 
                const url = `${this.$apiUrl_Quotation}/DownloadAttachFilesList/${purchaseId}/${item.guid}`;
                //const _self = this;
                return url;
            }
            return '#';
        },        
        isShowViewAttachFiles(item){// add by [Issue 2022-07-28 ,#02] 查詢附件
            if(item){                
               if(item.caseClosedCode === 'Y'){
                   return true;
               }
            }
            return false;
        }
    },
    mounted() {
        //let search= {}        
        //search.func =(key) => this.$t(key);
        //this.searchPurchase(search);
    }    
}
</script>
<style lang="scss" scoped>
@import '~bootstrap/scss/bootstrap.scss';


.table_body {
    overflow-x: auto;
    // overflow-y: auto;
    // overflow: auto;
    padding: 20px;
    > .table {
        // display: inline-block;
        margin-right: 0 20px;
        // padding-right: 20px;
    }
}

.btn-warning {
    color: #fff;

    &:hover {
        color: #fff;
    }
}

// .table tr:nth-child(even) {
//     background-color: transparent;
// }
</style>
